// sagas.js
import { call, put, takeEvery, take, } from 'redux-saga/effects';
import {
  FETCH_COMPANY_REQUEST,
  fetchCompanyFailure, 
  fetchCompanySuccess,
} from './actions';
import { api } from '../../api';

function* fetchCompanySaga() {
  try {
    const response = yield call(api.getCompany);
    yield put(fetchCompanySuccess(response.data));
  } catch (error) {
    yield put(fetchCompanyFailure(error.message));
  }
}

export function* watchFetchCompany() {
  yield takeEvery(FETCH_COMPANY_REQUEST, fetchCompanySaga);
}
